export default __webpack_public_path__ + "static/media/img-contacto-1.7da3423e.jpg";